var indentation_default = {
  "indentZero": "Nimny",
  "indentOne": "_8GOJA",
  "indentTwo": "LiolE",
  "indentThree": "AJQYS",
  "indentFour": "_7fqBG",
  "indentFive": "OytYj",
  "indentSix": "XQV1C"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
